import { createApiActions } from '../../../helpers/actions';

import { Site } from '../../../components/modules/sites/types';

export const getSites = createApiActions()(
  'company/getSites',
  'company/getSitesSuccess',
  'company/getSitesError',
  (page: number, searchText: string) => ({ page, searchText })
);

export const editSite = createApiActions()(
  'company/editSite',
  'company/editSiteSuccess',
  'company/editSiteError',
  (id: number, data: Site) => ({ id, data })
);
